import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap'
import { Link, Route, Routes } from "react-router-dom";
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import placeholder from '../img/placeholder.png';

import { apiGetCurrentUser } from '../api/api';

import CommunityPopup from "./CommunityPopup";

import './ExploreCommunity.css'

const ExploreCommunity = ({ community }) => {
    const [currentUser, setcurrentUser] = useState(null)

    const getCurrentUser = async () => {
        apiGetCurrentUser()
            .then((response) => {
                setcurrentUser(response.data.user)
            }).catch((err) => {
                err.response && alert(err.response.data.detail)
            })
    }

    useEffect(() => {
        getCurrentUser()
    }, [])

    return (
        <Row xs={'auto'} className="communities-container d-flex justify-content-center">
            {community && community.map((val, index) => {
                return (
                    <div key={index} className='card-col'>
                        <Col>
                            <div className="card-container">
                                <Link
                                    to={`community-popup`}
                                    state={{ content: val, user: currentUser }}
                                    style={{ textDecoration: 'none', color: 'black' }}
                                >
                                    <Card sx={{ width: 225 }} className="explore-card">
                                        <CardMedia
                                            component="img"
                                            height="100"
                                            image={val.image ? val.image: placeholder}
                                        />
                                        <CardContent>
                                            <Typography style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} gutterBottom variant="h7" component="div">
                                                {val.name}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Link>
                            </div>
                        </Col>
                    </div>
                )
            })}
            <Routes>
                <Route path="/community-popup" element={
                    <CommunityPopup />
                } />
            </Routes>
        </Row>
    )

}

export default ExploreCommunity;